<div class="sf" [class.is-pick]="isPick">
  <div class="sf-alert is-bad" role="alert" *ngIf="refusedActive && refusedCount > 0">
    <div class="sf-alert-text">
      <strong>{{ 'serialForm.refusedTitle' | translate: { count: refusedCount, noun: ((refusedCount === 1 ? 'serialForm.nounOne' : 'serialForm.nounMany') | translate), action: (actionKey | translate) } }}</strong>
      <span>{{ (untick ? 'serialForm.nothingSavedUntick' : 'serialForm.nothingSavedRemove') | translate }}</span>
    </div>
    <button type="button" class="sf-btn" (click)="dismissRefused()">
      {{ (untick ? (refusedCount === 1 ? 'serialForm.untickIt' : 'serialForm.untickThem') : (refusedCount === 1 ? 'serialForm.removeIt' : 'serialForm.removeThem')) | translate }}
    </button>
  </div>

  <div class="sf-alert is-bad" role="alert" *ngIf="failed && !(refusedActive && refusedCount > 0)">
    <div class="sf-alert-text">
      <strong>{{ 'serialForm.failedTitle' | translate }}</strong>
      <span *ngIf="!stale">{{ 'serialForm.failedText' | translate }}</span>
      <span *ngIf="stale">{{ 'serialForm.staleText' | translate: { onHand: staleOnHand } }}</span>
    </div>
    <button type="button" class="sf-btn" *ngIf="!stale" (click)="retry.emit()">{{ 'serials.tryAgain' | translate }}</button>
  </div>

  <div class="sf-box">
    <div class="sf-top">
      <div class="sf-strip" role="status">
        <div class="sf-strip-text">
          <span class="sf-eyebrow">{{ (variant === 'adjustDown' ? 'serialForm.takeOut' : variant === 'adjustUp' ? 'serialForm.addToStock' : 'quantity') | translate }}</span>
          <span class="sf-strip-note" *ngIf="variant === 'receive'">{{ 'serialForm.onePerSerial' | translate }}</span>
          <span class="sf-strip-note" *ngIf="variant === 'pick'">{{ 'serialForm.tickedOf' | translate: { total: stockTotal } }}</span>
          <span class="sf-strip-note" *ngIf="isAdjust">{{ (variant === 'adjustDown' ? (needed === 1 ? 'serialForm.tickOne' : 'serialForm.tickMany') : (needed === 1 ? 'serialForm.enterOne' : 'serialForm.enterMany')) | translate: { count: needed } }}</span>
        </div>
        <div class="sf-fig" [class.is-zero]="count === 0">
          <b>{{ count }}</b>
          <small *ngIf="!isAdjust">{{ (count === 1 ? 'serialForm.unitOne' : 'serialForm.unitMany') | translate }}</small>
          <small *ngIf="isAdjust">{{ 'serialForm.ofNeeded' | translate: { total: needed } }}</small>
        </div>
      </div>
      <div class="sf-progress" *ngIf="isAdjust" role="progressbar" [attr.aria-valuenow]="count" aria-valuemin="0" [attr.aria-valuemax]="needed" [class.is-done]="isFull">
        <span [style.width.%]="progress"></span>
      </div>

      <ng-container *ngIf="!isPick">
        <div class="sf-entry">
          <input #entryInput class="sf-input" type="text" autocomplete="off" autocapitalize="characters" spellcheck="false"
                 [(ngModel)]="entry" [disabled]="isFull || disabled"
                 [attr.aria-label]="'serialForm.scanOrType' | translate" [placeholder]="'serialForm.serialNumber' | translate"
                 (keydown.enter)="$event.preventDefault(); add()" />
          <button type="button" class="sf-btn" [disabled]="isFull || disabled || !entry.trim()" (click)="add()">{{ 'serialForm.add' | translate }}</button>
        </div>
        <p class="sf-note" aria-live="polite" [class.is-ok]="note?.kind === 'ok'" [class.is-bad]="note?.kind === 'bad'">
          <ng-container *ngIf="isAdjust && isFull">{{ 'serialForm.allIn' | translate: { count: needed } }}</ng-container>
          <ng-container *ngIf="!(isAdjust && isFull)">
            <ng-container *ngIf="note">{{ note.key | translate: note.params }}</ng-container>
            <ng-container *ngIf="!note">{{ (patternHint ? 'serialForm.readyPattern' : 'serialForm.ready') | translate: { pattern: patternHint } }}</ng-container>
          </ng-container>
        </p>
      </ng-container>

      <ng-container *ngIf="variant === 'pick'">
        <div class="sf-entry">
          <input class="sf-input" type="search" autocomplete="off" spellcheck="false" [(ngModel)]="entry" [disabled]="disabled || stockState !== 'ready'"
                 [attr.aria-label]="'serialForm.searchScan' | translate" [placeholder]="'serialForm.searchScan' | translate"
                 (ngModelChange)="onFilterInput()" (keydown.enter)="$event.preventDefault(); onSearchEnter()" />
        </div>
        <p class="sf-note" aria-live="polite" [class.is-ok]="note?.kind === 'ok'" [class.is-bad]="note?.kind === 'bad'" *ngIf="note">{{ note.key | translate: note.params }}</p>
      </ng-container>
    </div>

    <div class="sf-paste" *ngIf="!isPick && pasteOpen">
      <label class="sf-label" for="sf-paste-area">{{ 'serialForm.pasteLabel' | translate }}</label>
      <textarea id="sf-paste-area" class="sf-textarea" rows="5" spellcheck="false" [(ngModel)]="pasteText" [disabled]="disabled"></textarea>
      <div class="sf-paste-foot">
        <span class="sf-hint">{{ 'serialForm.pasteHint' | translate }}</span>
        <button type="button" class="sf-btn" [disabled]="disabled || pasteTokens.length === 0 || isFull" (click)="addPasted()">
          {{ 'serialForm.addToList' | translate: { count: pasteTokens.length } }}
        </button>
      </div>
    </div>

    <div class="sf-alert is-warn" role="status" *ngIf="!isPick && pasteDone && pasteSkipped.length > 0">
      <div class="sf-alert-text">
        <strong>{{ 'serialForm.pasteResult' | translate: { added: pasteAdded, left: pasteSkipped.length } }}</strong>
        <ul class="sf-skipped">
          <li *ngFor="let s of pasteSkipped"><code>{{ s.serial }}</code><span>{{ s.reasonKey | translate }}</span></li>
        </ul>
      </div>
    </div>

    <div class="sf-bar" *ngIf="!isPick">
      <span class="sf-bar-title">{{ 'serialForm.addedCount' | translate: { count: list.length } }}</span>
      <span class="sf-bar-actions">
        <button type="button" class="sf-link" [attr.aria-expanded]="pasteOpen" (click)="togglePaste()">{{ (pasteOpen ? 'serialForm.hidePaste' : 'serialForm.pasteList') | translate }}</button>
        <button type="button" class="sf-link" *ngIf="list.length > 0" [disabled]="disabled" (click)="clearAll()">{{ 'serialForm.clearAll' | translate }}</button>
      </span>
    </div>

    <div class="sf-bar" *ngIf="isPick && stockState === 'ready' && stockTotal > 0">
      <label class="sf-check-all" *ngIf="variant === 'pick' && shownCount > 0">
        <input type="checkbox" [checked]="allShownSelected" [indeterminate]="someShownSelected && !allShownSelected" [disabled]="disabled" (change)="toggleAllShown()" />
        <span>{{ (term ? 'serialForm.selectAllShown' : 'serialForm.selectAll') | translate: { count: shownCount } }}</span>
      </label>
      <span class="sf-bar-title" *ngIf="variant === 'adjustDown'">{{ 'serialForm.inStock' | translate: { count: stockTotal } }}</span>
      <span class="sf-bar-hint" *ngIf="variant === 'adjustDown' && isFull">{{ 'serialForm.untickToChange' | translate }}</span>
    </div>

    <div class="sf-find" *ngIf="showFilter">
      <input class="sf-input" type="search" autocomplete="off" spellcheck="false" [(ngModel)]="filter" (ngModelChange)="onFilterInput()"
             [attr.aria-label]="'serials.filter' | translate" [placeholder]="'serials.filter' | translate" />
    </div>

    <div class="sf-scroll">
      <div class="sf-state" *ngIf="isPick && stockState === 'loading'" aria-busy="true">
        <mat-spinner diameter="24"></mat-spinner>
      </div>
      <div class="sf-state" *ngIf="isPick && stockState === 'error'" role="alert">
        <strong>{{ 'serialForm.loadError' | translate }}</strong>
        <span>{{ 'serialForm.loadErrorText' | translate }}</span>
        <button type="button" class="sf-btn" (click)="reload.emit()">{{ 'serials.tryAgain' | translate }}</button>
      </div>
      <div class="sf-state" *ngIf="isPick && stockState === 'ready' && stockTotal === 0">
        <strong>{{ 'serialForm.emptyPickTitle' | translate }}</strong>
        <span>{{ 'serialForm.emptyPickText' | translate }}</span>
      </div>
      <div class="sf-state" *ngIf="!isPick && list.length === 0">
        <strong>{{ 'serialForm.emptyEnterTitle' | translate }}</strong>
        <span>{{ 'serialForm.emptyEnterText' | translate }}</span>
      </div>
      <div class="sf-state" *ngIf="term && rows.length === 0 && listTotal > 0 && (!isPick || stockState === 'ready')">
        <strong>{{ 'serialForm.noMatch' | translate: { term: term } }}</strong>
        <button type="button" class="sf-btn" (click)="clearFilter()">{{ 'serials.clearFilter' | translate }}</button>
      </div>

      <ul class="sf-rows" *ngIf="rows.length > 0">
        <ng-container *ngFor="let row of rows; trackBy: trackRow">
          <li class="sf-row" *ngIf="isPick" [class.is-selected]="row.selected" [class.is-off]="row.off" [class.is-bad]="row.bad">
            <label class="sf-row-main">
              <input type="checkbox" [checked]="row.selected" [disabled]="disabled || (row.off && !row.selected)" (change)="toggle(row)" />
              <span class="sf-row-text">
                <span class="sf-no">{{ row.serial }}</span>
                <span class="sf-meta" *ngIf="row.reasonKey">{{ row.reasonKey | translate }}</span>
                <span class="sf-meta" *ngIf="!row.reasonKey && row.receivedAt">{{ 'serials.received' | translate: { date: (row.receivedAt | date:'MMM d, y') } }}</span>
              </span>
            </label>
          </li>
          <li class="sf-row" *ngIf="!isPick" [class.is-bad]="row.bad">
            <span class="sf-row-main">
              <span class="sf-row-text">
                <span class="sf-no">{{ row.serial }}</span>
                <span class="sf-meta" *ngIf="row.reasonKey">{{ row.reasonKey | translate }}</span>
              </span>
            </span>
            <button type="button" class="sf-remove" [disabled]="disabled" (click)="removeSerial(row.serial)" [attr.aria-label]="('serialForm.remove' | translate) + ' ' + row.serial">
              <mat-icon>close</mat-icon>
            </button>
          </li>
        </ng-container>
      </ul>
    </div>
  </div>
</div>
